import { z } from 'zod';
import { freeze } from '@reduxjs/toolkit';

export const USERS_INVITE_LIMIT = 10;

const inviteUserCommonFields = z.object({
  email: z.string().email(),
  roleId: z.string().min(1, 'Role is required'),
  defaultSchemaId: z.string(),
  defaultView: z.string().min(1, 'Default view is required'),
});

const ssoEnabledInviteSchema = inviteUserCommonFields.extend({
  ssoEnabled: z.literal(true),
});
const ssoDisabledInviteSchema = inviteUserCommonFields.extend({
  ssoEnabled: z.literal(false),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
});
const userInviteSchema = z.discriminatedUnion('ssoEnabled', [
  ssoEnabledInviteSchema,
  ssoDisabledInviteSchema,
]);

export const userInvitesFormSchema = z.object({
  users: z.array(userInviteSchema),
});

export type IUserInvite = z.infer<typeof userInviteSchema>;
export type IInviteUsersModalState = z.infer<typeof userInvitesFormSchema>;

export const defaultInvite = (ssoEnabled: boolean) =>
  freeze<IUserInvite>(
    {
      ssoEnabled,
      firstName: '',
      lastName: '',
      email: '',
      roleId: '',
      defaultSchemaId: '',
      defaultView: '',
    },
    true,
  );
